import * as chefNetworkCoordinators from './chefNetwork'
import * as chefClientMapCoordinators from './chefClientMap'
import * as chefConfirmationsCoordinators from './chefConfirmations'

export default Object.freeze({
  ...chefNetworkCoordinators,
  ...chefClientMapCoordinators,
  ...chefConfirmationsCoordinators,
})
